import { all, call, put, takeLatest } from 'redux-saga/effects'
import { FETCH_APP_STATUS_TYPES, FETCH_APP_STATUS_TYPES_FAILED, FETCH_APP_STATUS_TYPES_SUCCESS } from '../actions/initAppActionTypes';
import { getProfile } from '../helpers/hasToken';

const API_URL = process.env.REACT_APP_API_SERVICE;

function getStatusTypes() {
    const profile = getProfile();
    return fetch(`${API_URL}/init/statustypes?schemaName=${profile.schema_name}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    }).then(response => response.json())
        .catch((error) => { throw error })
}

function* fetchStatusTypes() {
    try {
        const response = yield call(getStatusTypes);
        yield put({ type: FETCH_APP_STATUS_TYPES_SUCCESS, payload: response.data });
    } catch (e) {
        yield put({ type: FETCH_APP_STATUS_TYPES_FAILED, message: e.message });
    }
}

function* initAppFetchSagas() {
    yield all([
        yield takeLatest(FETCH_APP_STATUS_TYPES, fetchStatusTypes),
    ]);
}

export default initAppFetchSagas;